import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosNaturalViagens = {
    ...dadosAgenciaComum,
    id: 'naturalviagens',
    nome: 'Natural Viagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-NHVKV45']
};
